/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function getProductPackagingPropsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getProductPackagingPropsInput(productRecId: number): IDataServiceRequest {
    const query = getProductPackagingPropsQuery();
    return query.createDataServiceRequestForOperation(
        'GetProductPackagingProps',
        true,
        DataServiceEntities.GetProductPackagingPropsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetProductPackagingPropsResponse' },
        {
            productRecId: productRecId
        }
    );
}

export function getProductPackagingPropsAsync(
    context: IContext,
    productRecId: number
): AsyncResult<DataServiceEntities.IGetProductPackagingPropsResponse> {
    const request = getProductPackagingPropsInput(productRecId);
    return callActionOrExecute<DataServiceEntities.IGetProductPackagingPropsResponse>(request, context.callerContext);
}

function getProductCustomerPricesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getProductCustomerPricesInput(productRecId: number, custAccount: string): IDataServiceRequest {
    const query = getProductCustomerPricesQuery();
    return query.createDataServiceRequestForOperation(
        'GetProductCustomerPrices',
        true,
        DataServiceEntities.GetProductCustomerPricesResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetProductCustomerPricesResponse' },
        {
            productRecId: productRecId,
            custAccount: custAccount
        }
    );
}

export function getProductCustomerPricesAsync(
    context: IContext,
    productRecId: number,
    custAccount: string
): AsyncResult<DataServiceEntities.IGetProductCustomerPricesResponse> {
    const request = getProductCustomerPricesInput(productRecId, custAccount);
    return callActionOrExecute<DataServiceEntities.IGetProductCustomerPricesResponse>(request, context.callerContext);
}
